"use client";
import {NeoButton, NeoDatePicker, NeoTextBox} from "@/components/forms";
import {NeoError, NeoSuccess} from "@/components/shared";
import {driversService} from "@/service/drivers.service";
import {yupResolver} from "@hookform/resolvers/yup";
import {useEffect, useState} from "react";
import {Controller, useForm} from "react-hook-form";
import {AiOutlineLoading} from "react-icons/ai";
import * as yup from "yup";
type driverEditData = {
  userId: string;
  name: string;
  mobileNo: string;
  dateOfBirth: Date | null;
  licenceNo: string;
  licenceValidityDate: Date | null;
};
export const BasicInfoForm: React.FC<any> = function ({
  driverEditdata,
  getDriverData,
  onClose,
  handleNext
}) {
  const [loading, setLoading] = useState(false);
  const [preview, setPreview] = useState<string | null>(null);
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [succssMessage, setSuccessMessage] = useState<string | null>(null);
  // const {push} = useRouter();
  useEffect(() => {
    if (driverEditdata) {
      if (driverEditdata.driverPhoto) {
        setPreview(driverEditdata.driverPhoto);
      }
      reset(driverEditdata);
    }
  }, [driverEditdata]);
  const validationSchema = yup.object().shape({
    name: yup
      .string()
      .matches(/^[a-zA-Z\s]+$/, "Name can only contain letters and spaces")
      .required("Name is required"),

    mobileNo: yup
      .string()
      .matches(/^[6-9]\d{9}$/, "Mobile number must be a valid")
      .required("Mobile number is required"),

    dateOfBirth: yup
      .date()
      .nullable()
      .typeError("Enter the Valid Date")
      .max(new Date(), "Date of Birth cannot be in the future")
      //  .max(subYears(new Date(), 18), "Driver must be at least 18 years old")
      .max(
        new Date(
          new Date().getFullYear() - 18,
          new Date().getMonth(),
          new Date().getDate()
        ),
        "Driver must be at least 18 years old"
      )
      .transform((value, originalValue) => {
        return originalValue === "" ? null : value;
      }),
    //   .date()
    //   .max(new Date(), "Date of Birth cannot be in the future")
    //   .required("Date of Birth is required"),

    licenceNo: yup.string(),
    // .matches(/^[a-zA-Z0-9]+$/, "License number must be alphanumeric"),
    //   .required("License number is required")
    licenceValidityDate: yup
      .date()
      .nullable()
      .typeError("Enter the Valid Date")
      //   .min(new Date(), "Date of Birth cannot be in the future")
      .transform((value, originalValue) => {
        return originalValue === "" ? null : value;
      })
    // .required("License expdate is required")
  });

  const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      setSelectedFile(file);
      const reader = new FileReader();
      reader.onloadend = () => setPreview(reader.result as string);
      reader.readAsDataURL(file);
    }
  };
  const {
    register,
    handleSubmit,
    formState: {isSubmitting, errors},
    control,
    setError,
    setValue,
    reset,
    clearErrors
  } = useForm<any>({
    //defaultValues: editData,
    mode: "onChange",
    resolver: yupResolver(validationSchema)
  });
  const formatDate = (date: Date | null): string | null => {
    if (!date) return null;
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-based
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };
  const onSubmit = async (data: any) => {
    setLoading(true);

    const payload: Record<string, any> = {
      userId: driverEditdata.driverId,
      name: data.name,
      phone: data.mobileNo,
      dob: data.dateOfBirth ? formatDate(data.dateOfBirth) : null,
      licenseNumber: data.licenceNo,
      licenseValidityDate: data.licenceValidityDate
        ? formatDate(data.licenceValidityDate)
        : null,
      instituteId: driverEditdata.institutionId,
      loginUserId: driverEditdata.userId
    };
    if (selectedFile) {
      payload.driverPhoto = selectedFile;
    }
    const formData = new FormData();
    if (payload.userId) {
      formData.append("userId", payload.userId);
    }
    formData.append("name", payload.name);
    formData.append("phone", payload.phone);
    if (payload.licenseValidityDate) {
      formData.append("licenseValidityDate", payload.licenseValidityDate);
    }
    if (payload.dob) {
      formData.append("dob", payload.dob);
    }
    formData.append("licenseNumber", payload.licenseNumber);
    formData.append("instituteId", payload.instituteId);
    formData.append("loginUserId", payload.loginUserId);
    if (selectedFile) {
      formData.append("driverPhoto", selectedFile);
    }
    //formData.append("driverPhoto", payload.driverPhoto);
    // for (const key in payload) {
    //   if (payload[key] !== null && payload[key] !== undefined) {
    //     formData.append(key, payload[key]);
    //   }
    // }
    // console.log("formData", formData);
    // return;
    if (driverEditdata.driverId) {
      await driversService
        .updateDriverdata(formData)
        .then((response: any) => {
          if (response?.data?.status === "success") {
            //push(`/drivers`);
            setSuccessMessage(response?.data?.message);
          } else {
            setErrorMessage(response?.data?.message);
          }
        })
        .catch(err => {
          if (err?.errors.length > 0) {
            err?.errors.forEach(
              ({field, message}: {field: any; message: string}) => {
                setError(field, {type: "server", message: message});
              }
            );
          }
        })
        .finally(() => {
          setLoading(false);
          setTimeout(() => {
            setErrorMessage(null);
          }, 2000);
          setTimeout(() => {
            setSuccessMessage(null);
          }, 2000);
        });
    } else {
      await driversService
        .addDriverdata(formData)
        .then((response: any) => {
          if (response?.data?.status === "success") {
            setSuccessMessage(response?.data?.message);
            getDriverData(response?.data?.data?.userId);
            handleNext();
          } else {
            setErrorMessage(response?.data?.message);
          }
        })
        .catch(err => {
          if (err?.errors.length > 0) {
            err?.errors.forEach(
              ({field, message}: {field: any; message: string}) => {
                setError(field, {type: "server", message: message});
              }
            );
          }
        })
        .finally(() => {
          setLoading(false);
          setTimeout(() => {
            setErrorMessage(null);
          }, 2000);
          setTimeout(() => {
            setSuccessMessage(null);
          }, 2000);
        });
    }

    // .finally(() => {
    //   setLoading(false);
    //   setTimeout(() => {
    //     setErrorMessage(null);
    //   }, 2000);
    // });
  };

  const onDateChange = (name: any, event: any) => {
    clearErrors(name);
    setValue(name, event);
  };

  return (
    <div className="w-full rounded-lg  border border-gray-200 p-1 shadow-md">
      {/* onSubmit={handleSubmit(onSubmit)} */}
      <div className="rouned-lg mb-2 flex flex-col justify-start border-b-2 border-gray-200 bg-white p-4">
        <h2 className="text-lg font-semibold">Basic Information</h2>
        <p className="text-sm text-gray-500">
          Please fill in the basic information of the driver.
        </p>
      </div>
      <form onSubmit={handleSubmit(onSubmit)} className="w-full px-5">
        <div className="flex items-center justify-between">
          <div className="flex flex-col items-center gap-2 pb-4">
            <div className="relative h-24 w-24 overflow-hidden rounded-full bg-gray-100 shadow-md">
              {preview ? (
                <img
                  src={preview}
                  alt="Preview"
                  className="h-full w-full object-cover"
                />
              ) : (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={1.5}
                  stroke="currentColor"
                  className="h-full w-full p-4 text-gray-400"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.5 20.25a8.25 8.25 0 0115 0"
                  />
                </svg>
              )}
            </div>

            <label className="mt-2 cursor-pointer rounded-md bg-blue-100 px-4 py-2 text-sm font-semibold text-blue-700 hover:bg-blue-200">
              Upload Image
              <input
                type="file"
                accept="image/*"
                onChange={handleImageChange}
                className="hidden"
              />
            </label>
          </div>
          <div className="flex flex-col items-center gap-2 pb-4">
            <Controller
              name="name"
              control={control}
              render={({field}) => (
                <NeoTextBox
                  {...field}
                  label="Name"
                  id="name"
                  //  defaultValue={editData?.name}
                  placeholder="Enter name"
                  color={errors.name ? "danger" : "default"}
                  isInvalid={errors.name ? true : false}
                  errorMessage={errors.name && `${errors.name.message}`}
                  {...register("name")}
                />
              )}
            />
            <Controller
              name="mobileNo"
              control={control}
              render={({field}) => (
                <NeoTextBox
                  {...field}
                  label="Phone No"
                  id="phone No"
                  //  defaultValue={editData?.mobileNo}
                  placeholder="Enter phone number"
                  color={errors.mobileNo ? "danger" : "default"}
                  isInvalid={errors.mobileNo ? true : false}
                  errorMessage={errors.mobileNo && `${errors.mobileNo.message}`}
                  {...register("mobileNo")}
                />
              )}
            />
          </div>
        </div>

        <div className="mb-2 grid w-full grid-cols-2 gap-2 max-sm:grid-cols-1">
          <Controller
            name="dateOfBirth"
            control={control}
            render={({field: {ref, value, onChange, ...fieldRest}}) => (
              <NeoDatePicker
                {...fieldRest}
                label="Date of Birth"
                placeholder="Select dob"
                errorMessage={
                  errors.dateOfBirth && `${errors.dateOfBirth.message}`
                }
                //minDate={mindate}
                value={value}
                handleDateChange={(e: any) => {
                  onChange(e);
                  onDateChange("dateOfBirth", e);
                }}
              />
            )}
          />

          <Controller
            name="licenceValidityDate"
            control={control}
            render={({field: {ref, value, onChange, ...fieldRest}}) => (
              <NeoDatePicker
                {...fieldRest}
                label="License Expiry Date"
                placeholder="Select license expiry Date"
                errorMessage={
                  errors.licenceValidityDate &&
                  `${errors.licenceValidityDate.message}`
                }
                //minDate={mindate}
                value={value}
                handleDateChange={(e: any) => {
                  onChange(e);
                  onDateChange("licenceValidityDate", e);
                }}
              />
            )}
          />
        </div>
        <div className="mb-2 grid w-full grid-cols-1 gap-2 max-sm:grid-cols-1">
          <Controller
            name="licenceNo"
            control={control}
            render={({field}) => (
              <NeoTextBox
                {...field}
                label="License Number"
                id="License Number"
                placeholder="Enter license number"
                color={errors.licenceNo ? "danger" : "default"}
                // defaultValue={editData?.licenceNo}
                isInvalid={errors.licenceNo ? true : false}
                errorMessage={errors.licenceNo && `${errors.licenceNo.message}`}
                {...register("licenceNo")}
              />
            )}
          />
        </div>

        <div className="flex flex-col items-center justify-end p-4">
          <NeoButton
            className="mx-2 mt-2"
            type="submit"
            size="sm"
            disabled={isSubmitting}
            isLoading={loading}
            spinner={
              <AiOutlineLoading size="xs" className="animate-spin h-6 w-6" />
            }
            color="black"
          >
            Submit
          </NeoButton>
          {errorMessage ? <NeoError message={errorMessage}></NeoError> : null}

          {succssMessage ? (
            <NeoSuccess message={succssMessage}></NeoSuccess>
          ) : null}
          {/* <NeoButton
            className="mx-2 mt-2"
            type="submit"
            size="sm"
            disabled={isSubmitting}
            isLoading={loading}
            spinner={
              <AiOutlineLoading size="xs" className="animate-spin h-6 w-6" />
            }
            color="black"
            onClick={handleNext}
          >
            Next
          </NeoButton> */}
        </div>
      </form>
    </div>
  );
};
